import { UseFormRegisterReturn } from "react-hook-form";
import Product from "../../../types/product";
import Price from "../price";

export interface ISuggestItemProps {
  product: Product;
  mandatory?: boolean;
  selected?: boolean;
  register: UseFormRegisterReturn;
}

export default function SuggestItem({
  product: { identifier, title, price },
  mandatory,
  selected,
  register,
}: ISuggestItemProps) {
  if (identifier === undefined || identifier === null) {
    console.error("Product identifier is undefined or null", {
      identifier,
      title,
      price,
    });
    return null;
  }

  return (
    <tr>
      <td>
        <input
          id={identifier.toString()}
          value={identifier.toString()}
          type="checkbox"
          defaultChecked={selected}
          disabled={mandatory}
          {...register}
        />
      </td>
      <td className="px-2">{title}</td>
      <td className="px-2 font-bolder">
        <Price amount={price} />
      </td>
    </tr>
  );
}
